// External libraries
import React, { useEffect } from 'react';

// Internal modules
import { features } from '@/lib/features';
import { logger } from '@/lib/logger';
import { OptionalPassword } from './OptionalPassword';
import { OptionalPasswordless } from './OptionalPasswordless';

export const OptionalSignup = (): JSX.Element => {
  const isPasswordless = features.isActive('passwordlessOptionalSignup');

  useEffect(() => {
    logger.info(
      isPasswordless
        ? 'rendering_streamline_passwordless_optional_sign_up_flow'
        : 'rendering_optional_sign_up_flow',
    );
  }, []);

  if (isPasswordless) {
    return <OptionalPasswordless />;
  }

  return <OptionalPassword />;
};
